import { CanDeactivateFn } from '@angular/router';
import { AppComponent } from '../app.component';
import { TablesPlanComponent } from '../tables-plan/tables-plan.component';

export const hasUnsavedChangesGuard: CanDeactivateFn<TablesPlanComponent> = (component, currentRoute, currentState, nextState) => {

  if (component?.isDirty == null || component.isDirty !== true) {
    return true;
  }

  alert('Changes you made are not saved! Please save your changes and try again.');
  return false;
};
